// ============================================================================
// SHELL SORT - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'shell-sort',
  name: 'Shell Sort',
  category: 'Sorting',
  complexity: {
    time: 'O(n log² n) average/worst, O(n log n) best',
    space: 'O(1)'
  },
  description: 'Shell Sort is an optimization of insertion sort that allows the exchange of items that are far apart. It works by sorting elements at various gaps, starting with a large gap and progressively reducing it.'
};
export type MetaType = typeof meta;
